export const recentTransactions = {
  emptyLabel:
    'você ainda não tem transações <br /> recentes, quando você tiver <br /> elas irão aparecer aqui',
  title: 'Transações recentes',
  to: 'Para:',
  from: 'De:'
};
